import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Follow.css'
import IconSvgFacebook from './IconSvgFacebook.jsx'
import IconSvgTwitter from './IconSvgTwitter.jsx'
import IconSvgInstagram from './IconSvgInstagram.jsx'

/**
 * Follow Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Follow extends Component {
  /**
   * Default props
   *
   * @type {{containerClass: string, facebookUrl: string, facebookVisible: boolean, headerText: string, instagramUrl: string, instagramVisible: boolean, twitterUrl: string, twitterVisible: boolean}}
   */
  static defaultProps = {
    containerClass: 'Follow',
    facebookUrl: 'https://www.facebook.com',
    facebookVisible: true,
    headerText: 'Follow us',
    instagramUrl: 'https://www.instagram.com',
    instagramVisible: true,
    openInNewTab: true,
    twitterUrl: 'https://twitter.com',
    twitterVisible: true
  }

  /**
   * Prop Types
   *
   * @type {{containerClass: shim, facebookUrl: shim, facebookVisible: shim, headerText: shim, instagramUrl: shim, instagramVisible: shim, twitterUrl: shim, twitterVisible: shim}}
   */
  static propTypes = {
    containerClass: PropTypes.string,
    facebookUrl: PropTypes.string,
    facebookVisible: PropTypes.bool,
    headerText: PropTypes.string,
    instagramUrl: PropTypes.string,
    instagramVisible: PropTypes.bool,
    openInNewTab: PropTypes.bool,
    twitterUrl: PropTypes.string,
    twitterVisible: PropTypes.bool
  }

  /**
   * State
   *
   * @type {{target: string}}
   */
  state = {
    target: '_self'
  }

  /**
   * Component did mount
   */
  componentDidMount() {
    if (this.props.openInNewTab === true) {
      this.setState({
        target: '_blank'
      })
    }
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const {
      containerClass,
      facebookVisible,
      facebookUrl,
      instagramUrl,
      instagramVisible,
      twitterVisible,
      twitterUrl
    } = this.props
    const { target } = this.state

    return (
      <div className={containerClass}>
        {/* <span className="Label">{headerText}</span> */}

        <div>
          <a href={facebookUrl} target={target}>
            {facebookVisible && <IconSvgFacebook />}
          </a>
          <a href={twitterUrl} target={target}>
            {twitterVisible && <IconSvgTwitter />}
          </a>
          <a href={instagramUrl} target={target}>
            {instagramVisible && <IconSvgInstagram />}
          </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global/follow/Follow.jsx